    <div fxLayout="row"
        [ngClass]="{
            'menu-opened': userSettings.settings.menuColumnToggle, 
            'notify-opened': userSettings.settings.notificationColumnToggle,
            desktop: sizeClass == 'desktop',
            tablet: sizeClass == 'tablet',
            mobile: sizeClass == 'mobile'
        }">
        <div class="dark drawer" role="naviagation" id="menu" [ngClass]="{opened: userSettings.settings.menuColumnToggle}">
            <menu-component></menu-component>
        </div>
        <form autocomplete="off" id="main" fxFlex>
            <router-outlet></router-outlet>
        </form>
        <div class="light drawer right" id="notifications" [ngClass]="{opened: userSettings.settings.notificationColumnToggle}">
            <notifications-component></notifications-component>
        </div>
    </div>